import { AddressPost } from '../models/address-post';

export class Instructor {

  constructor() {
    this.id = '';
    this.active = true;
    this.addressId = '';
    this.address = new AddressPost();
    this.birthYear = '';
    this.cellPhone = '';
    this.certificationDate = '';
    this.classGroupId = 0;
    this.contAmt = 0;
    this.dayNumber = '';
    this.dln = '';
    this.email = '';
    this.eveningNumber = '';
    this.faxNumber = '';
    this.feeDefault = 0;
    this.firstName = '';
    this.lastName = '';
    this.note = '';
    this.priorInstructorId = 0;
    this.reCertificationDate = '';
    this.regionId = 0;
    this.sequence = 0;
    this.ssn = '';
    this.vdn = '';
  }

  id: string;
  active: boolean;
  addressId: string;
  address: AddressPost;
  birthYear: string;
  cellPhone: string;
  certificationDate: string;
  classGroupId: number;
  contAmt: number;
  dayNumber: string;
  dln: string;
  email: string;
  eveningNumber: string;
  faxNumber: string;
  feeDefault: number;
  firstName: string;
  lastName: string;
  note: string;
  priorInstructorId: number;
  reCertificationDate: string;
  regionId: number;
  sequence: number;
  ssn: string;
  vdn: string;

}



// WEBPACK FOOTER //
// ./src/app/models/instructor.ts